module.exports = __webpack_public_path__ + "static/media/paperboard-side2.f5fd4cb5.jpg";